import { Stack, Typography, useTheme } from "@mui/material";
import { CheckCircle2 } from "lucide-react";
import type { FC } from "react";
import { RealizationStepRow } from "web_myplann/Goals/Components/RealizationStepRow";
import type { RealizationStep } from "web_myplann/Goals/Hooks/useRealizationContent";

type Props = {
	kicker: string;
	title: string;
	description: string;
	steps: RealizationStep[];
};

export const RealizationSummary: FC<Props> = ({
	kicker,
	title,
	description,
	steps,
}) => {
	const theme = useTheme();
	const accent = theme.palette.realization.main;

	return (
		<Stack gap={theme.spacingTokens.lg}>
			<Stack>
				<Stack
					direction="row"
					alignItems="center"
					gap={theme.spacingTokens.xsm}
					alignSelf="flex-start"
					px={1}
					py={theme.spacingTokens.xs}
					mb={theme.spacingTokens.md}
					borderRadius={theme.shape.pillRadius}
					bgcolor={theme.hero.pillBg}
				>
					<CheckCircle2 size={theme.iconSize.xxs} color={accent} />
					<Typography variant="overline" color={theme.palette.grey[700]}>
						{kicker}
					</Typography>
				</Stack>

				<Typography variant="h2">{title}</Typography>
				<Typography variant="note" mt={theme.spacingTokens.xsm}>
					{description}
				</Typography>
			</Stack>

			<Stack gap={1}>
				{steps.map((step) => (
					<RealizationStepRow key={step.title} step={step} accent={accent} />
				))}
			</Stack>
		</Stack>
	);
};
